export const categories = [
  {
    title: 'Highlights',
    description:
      'A starter pack containing the impactful networking and cloud technologies... you want to read about. A clear and concise guide, prepared for you.',
    link: '/blog/highlights/',
  },
  {
    title: 'Deep dive',
    description:
      'Real-life challenges and research cases solved and presented by CodiLime’s... engineering and R&D teams. A deep dive into deep dev. ',
    link: '/blog/deep-dive/',
  },
  {
    title: 'Business insights',
    description:
      'Current trends tracked and packaged in a series of articles to give you the... necessary insights to help your business grow.',
    link: '/blog/business-insights/',
  },
  {
    title: 'All articles',
    description: 'Show all articles',
    link: '/blog/',
  },
];
